
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.097 10.065a.9.9 0 01-1.265-1.282L7.405 5.26a.9.9 0 011.27.007l3.5 3.524a.9.9 0 01-1.278 1.268L8.03 7.171l-2.933 2.894z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    